<template>
  <div class="contentTitle">
    <h3>{{ title }}</h3>
    <img class="titleBorder" src="@img/title_underline@2x.png" />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="less" scoped>
.contentTitle {
  display: flex;
  align-items: center;
  flex-direction: column;
  h3 {
    font-size: 34px;
    color: #333333;
    font-weight: normal;
  }
  .titleBorder {
    margin-top: 16px;
    width: 384px;
    height: 23px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/title.vue